import withResponsive from 'components/Layout/withResponsive';
import PropTypes from 'prop-types';
import { PaginationComponent } from './Pagination';

class PaginationSetExternalPager extends PaginationComponent {
    static propTypes = { ...PaginationComponent.propTypes, setPagerProps: PropTypes.func }
    static defaultProps = {
      ...PaginationComponent.defaultProps,
      setPagerProps: () => {},
    };
    componentDidUpdate(prevProps, prevState) {
      super.componentDidUpdate(prevProps, prevState);
      const { currentPage, endPage } = this.state.pager;

      if (currentPage !== prevState.pager.currentPage) {
        const pager = { ...this.state.pager, currentPage: currentPage === endPage ? 'last' : currentPage };
        this.props.setPagerProps(pager);
      }
    }
}

export default withResponsive(PaginationSetExternalPager);
